import APIClient from "web_modules/APIClient";

import { DocShape } from "@eave/shared/types/api";

export const generatePostClosingPdf = async (
  appId: number,
  docType: string,
  targetDate: string | null,
) => {
  return APIClient.post(`/uw/${appId}/generate_post_closing_pdf`, {
    document_type: docType,
    target_date: targetDate, // null if doesn't apply to this doc type
  });
};

export const markDocsUnused = async (docs: DocShape[]) => {
  return APIClient.put(`/document_field_list`, {
    document_fields: docs.map((d: DocShape) => ({
      document_id: d.id,
      section: "used",
      field_key: "not_used",
      field_value: "true",
    })),
  });
};
